import { Link } from "react-router-dom";
import { AlertTriangle, HardDrive, RefreshCw, ShieldAlert } from "lucide-react";
import { PageHero } from "@/components/layout/PageHero";
import { PhoneArt } from "@/components/install/PhoneArt";
import { useI18n } from "@/i18n/I18nContext";

const STEPS = ["download", "open", "unknown", "install", "launch"];
const TROUBLE = [
  { id: "t1", Icon: AlertTriangle },
  { id: "t2", Icon: ShieldAlert },
  { id: "t3", Icon: HardDrive },
  { id: "t4", Icon: RefreshCw },
];

export default function InstallGuide() {
  const { t } = useI18n();
  return (
    <div data-testid="install-guide-page">
      <PageHero eyebrow={t("install.eyebrow")} title={t("install.title")}>
        <p className="mt-4 max-w-2xl text-sm text-neutral-300 md:text-base" data-testid="install-intro">{t("install.intro")}</p>
      </PageHero>
      <div className="mx-auto max-w-5xl space-y-12 px-4 sm:px-8">
        <ol className="space-y-5" data-testid="install-steps">
          {STEPS.map((kind, i) => (
            <li key={kind} className="card-carbon fade-up flex flex-col items-center gap-5 rounded-2xl p-5 sm:flex-row sm:items-center sm:gap-8" style={{ animationDelay: `${i * 70}ms` }} data-testid={`install-step-${i + 1}`}>
              <PhoneArt kind={kind} label={t(`install.s${i + 1}.title`)} />
              <div className="min-w-0">
                <p className="font-display text-xs font-bold uppercase tracking-[0.3em] text-[var(--red-bright)]">{t("install.step", { n: i + 1 })}</p>
                <h2 className="mt-1 font-display text-base font-bold text-[var(--gold-bright)] md:text-lg">{t(`install.s${i + 1}.title`)}</h2>
                <p className="mt-2 text-sm leading-relaxed text-neutral-300">{t(`install.s${i + 1}.text`)}</p>
              </div>
            </li>
          ))}
        </ol>
        <section data-testid="install-troubleshooting">
          <h2 className="font-display text-base font-bold uppercase tracking-wider text-white md:text-lg">{t("install.trouble")}</h2>
          <div className="mt-5 grid gap-4 md:grid-cols-2">
            {TROUBLE.map(({ id, Icon }) => (
              <article key={id} className="rounded-2xl border border-[rgba(208,20,31,0.45)] bg-[rgba(74,6,11,0.35)] p-5" data-testid={`install-trouble-${id}`}>
                <h3 className="flex items-center gap-2 font-semibold text-white"><Icon className="h-5 w-5 shrink-0 text-[var(--gold)]" /> {t(`install.${id}.title`)}</h3>
                <p className="mt-2 text-sm leading-relaxed text-neutral-300">{t(`install.${id}.text`)}</p>
              </article>
            ))}
          </div>
        </section>
        <Link to="/apps" className="btn-gold btn-cta" data-testid="install-back-catalogue">{t("install.back")}</Link>
      </div>
    </div>
  );
}
